/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BuildingBlockType {
  TEXT = 'text',
  IMAGE = 'image',
  LINE_BREAK = 'lineBreak',
  RETURNING_CUSTOMER = 'returningCustomer',
  REVIEWS = 'reviews',
}
